import { MenuItem as MuiMenuItem, Stack } from '@mui/material';

import BaseAppLink from '@/components/AppLink';
import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const Container = styled(Stack)(({ theme }) => ({
  width: 290,
  minWidth: 290,
  height: '100%',
  backgroundColor: theme.palette.background.subtle,
  borderRight: getBorder(theme.palette.border.default),
}));

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(0),
  height: 32,

  '[data-cy="actions-menu"]': {
    display: 'none',
  },

  '&:hover [data-cy="actions-menu"]': {
    display: 'block',
  },
}));

const AppLink = styled(BaseAppLink)(({ theme }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  textDecoration: 'none',
  color: theme.palette.text.default,

  '&:hover': {
    color: theme.palette.text.default,
    textDecoration: 'none',
  },
}));

export { Container, MenuItem, AppLink };
